import React__default from 'react';
import { LoaderScreen } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusSuccess } from '@grandvisionhq/state';
import { ProductSelectionStep } from '../components/ProductSelectionStep/ProductSelectionStep.js';
import { getSelectedVariantParentSku } from '../utils/get-selected-variant-parent-sku.js';
import { getSelectedFrame, getLensTypes, getSelectedLensType } from '../../../state/configurator/selectors.js';
import { selectLensType } from '../../../state/configurations/actions.js';

const LensTypeStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const lensTypes = useSelector(getLensTypes);
    const selectedLensType = useSelector(getSelectedLensType);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectLensType({
            frameSku: frame.sku,
            lensTypeSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame === null || frame === void 0 ? void 0 : frame.sku
    ]);
    if (!statusSuccess(lensTypes)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    const lensTypeList = lensTypes.result;
    let selectedLensTypeParentSku;
    if (selectedLensType) {
        selectedLensTypeParentSku = getSelectedVariantParentSku(lensTypeList, selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku);
    }
    return /*#__PURE__*/ React__default.createElement(ProductSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: lensTypeList,
        selectedItemSku: selectedLensTypeParentSku || (selectedLensType === null || selectedLensType === void 0 ? void 0 : selectedLensType.sku)
    });
};

export { LensTypeStepContainer };
//# sourceMappingURL=LensTypeStepContainer.js.map
